export const nazareno = {
	nombre: "Nazareno",
	dia: "Jueves Santo",
	nombrecompleto:
		"Inmemorial, Venerable, Pontificia y Real Cofradía de Nuestro Padre Jesús Nazareno, Santa Cruz de Jerusalén y María Santísima de los Dolores",
	sede: "Iglesia Conventual de Santa María",
	pasos: 2,
	distancia: [553, 2150],
	penitentes: 220,
	cargadores: 96,
	web: "http://www.diariodecadiz.es/semana_santa/Nazareno_0_1229577728.html",

	ida: [
		{ lng: -6.2918361, lat: 36.5277227 },
		{ lng: -6.2918977, lat: 36.5277367 },
		{ lng: -6.2918629, lat: 36.5278272 },
		{ lng: -6.2920868, lat: 36.5281117 },
		{ lng: -6.2923242, lat: 36.5282927 },
		{ lng: -6.2923819, lat: 36.5283908 },
		{ lng: -6.2924463, lat: 36.5284404 },
		{ lng: -6.2924194, lat: 36.528518 },
		{ lng: -6.2925509, lat: 36.5288089 },
		{ lng: -6.2925629, lat: 36.529115 },
		{ lng: -6.2926501, lat: 36.529185 },
		{ lng: -6.2925053, lat: 36.5295514 },
		{ lng: -6.2927788, lat: 36.5297551 },
		{ lng: -6.2929344, lat: 36.5298144 },
		{ lng: -6.2931329, lat: 36.5297928 },
		{ lng: -6.2932751, lat: 36.5297346 },
		{ lng: -6.2945293, lat: 36.529632 },
		{ lng: -6.2946095, lat: 36.5295557 },
		{ lng: -6.2950855, lat: 36.5296247 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957051, lat: 36.5290816 },
		{ lng: -6.2954262, lat: 36.5297605 },
		{ lng: -6.2956689, lat: 36.5299523 },
		{ lng: -6.2952834, lat: 36.5303564 },
		{ lng: -6.2950212, lat: 36.5308327 },
		{ lng: -6.2949219, lat: 36.5308349 },
		{ lng: -6.2949219, lat: 36.5314524 },
		{ lng: -6.2964723, lat: 36.5317843 },
		{ lng: -6.2964106, lat: 36.5318662 },
		{ lng: -6.2965782, lat: 36.5321345 },
		{ lng: -6.2967928, lat: 36.5325408 },
		{ lng: -6.2965742, lat: 36.5327778 },
		{ lng: -6.2964159, lat: 36.5329438 },
		{ lng: -6.2962604, lat: 36.5332417 },
		{ lng: -6.2963381, lat: 36.5333059 },
		{ lng: -6.296253, lat: 36.5339384 },
		{ lng: -6.2954503, lat: 36.5340203 },
		{ lng: -6.2949327, lat: 36.5333834 },
		{ lng: -6.294069, lat: 36.5323877 },
		{ lng: -6.293236, lat: 36.5314397 },
		{ lng: -6.2929371, lat: 36.5316086 },
		{ lng: -6.2919863, lat: 36.5304944 },
		{ lng: -6.2922169, lat: 36.5302864 },
		{ lng: -6.2915296, lat: 36.5298079 },
		{ lng: -6.2908869, lat: 36.5294447 },
		{ lng: -6.2902034, lat: 36.5291166 },
		{ lng: -6.290378, lat: 36.5289277 },
		{ lng: -6.2904546, lat: 36.5287622 },
		{ lng: -6.2902113, lat: 36.5286244 },
		{ lng: -6.2897845, lat: 36.5282409 },
		{ lng: -6.2898065, lat: 36.5280038 },
		{ lng: -6.2901031, lat: 36.5270717 },
		{ lng: -6.2911996, lat: 36.527395 },
		{ lng: -6.2914018, lat: 36.5269305 },
		{ lng: -6.2916022, lat: 36.527055 },
		{ lng: -6.2920698, lat: 36.5273931 },
		{ lng: -6.2919027, lat: 36.5277109 },
		{ lng: -6.2918428, lat: 36.5276973 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-29T20:00",
			latlng: [36.52771, -6.29183]
		},
		{
			name: "Nueva",
			hora: "2018-03-29T21:30",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-29T22:30",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-29T23:30",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-29T23:55",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T00:05",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Santa María",
			"Jabonería",
			"San Juan de Dios",
			"Plaza de San Juan de Dios",
			"Avda. 4 de Diciembre de 1977",
			"Cristobal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cádiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Sánchez Barcaiztegui",
			"Avda. 4 de Diciembre de 1977",
			"Plaza San Juan de Dios (centro)",
			"Plocia",
			"Compás de Santo Domingo",
			"Santo Domingo",
			"Mirador",
			"Público",
			"Concepción Arenal",
			"Santa María"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/nazareno.js